import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';

/**
 * Active / inactive badge of both referential screens. A dot plus the word, never colour alone —
 * and the emerald/zinc pair rather than the default badge variants, which read as "primary" and
 * would make every active row shout.
 */
const StatusCell = ({ active }: { active: boolean }) => {
  const { t } = useTranslation();

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium',
        active
          ? 'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-900/50 dark:bg-emerald-950/40 dark:text-emerald-300'
          : 'border-zinc-200 bg-zinc-50 text-zinc-500 dark:border-zinc-700 dark:bg-zinc-800/60 dark:text-zinc-400'
      )}
    >
      <span
        className={cn('h-1.5 w-1.5 rounded-full', active ? 'bg-emerald-500' : 'bg-zinc-400')}
        aria-hidden="true"
      />
      {active ? t('Active') : t('Inactive')}
    </span>
  );
};

export default StatusCell;
